import React, { useState } from 'react';
import { useI18n } from '../i18n/I18nContext';

function AddPersonel({ onAdd, onClose }) {
    const { t } = useI18n();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');
    const [type, setType] = useState('');
    const [permissions, setPermissions] = useState({
        'manage-tables': false, // masalar
        'manage-quick-orders': false, // sifarisler
        'manage-customers': false, // musteri
        'access-payments': false, // kasaya erise bilsin
        'manage-payments': false, // kasadan veri silsin
        'manage-tanimlar': false, // tanitimlar
        'manage-restaurants': false, // qenel ayarlar
    });
    const [errors, setErrors] = useState<any>({});

    // Маппинг для отображения прав в удобочитаемые строки
    const permissionLabels = {
        'manage-tables': t("staff.perm.tables"), // masalar
        'manage-quick-orders': t("staff.perm.orders"), // sifarisler
        'manage-customers': t("staff.perm.customers"), // musteri
        'access-payments': t("staff.perm.accessPayments"), // kasaya erise bilsin
        'manage-payments': t("staff.perm.managePayments"), // kasadan veri silsin
        'manage-tanimlar': t("staff.perm.definitions"), // tanitimlar
        'manage-restaurants': t("staff.perm.settings"), // qenel ayarlar
    };

    const handleTypeChange = (e) => {
        setType(e.target.value);
        if (e.target.value !== 'general') {
            setPermissions({
                'manage-tables': false, // masalar
                'manage-quick-orders': false, // sifarisler
                'manage-customers': false, // musteri
                'access-payments': false, // kasaya erise bilsin
                'manage-payments': false, // kasadan veri silsin
                'manage-tanimlar': false, // tanitimlar
                'manage-restaurants': false, // qenel ayarlar
            });
        }
    };

    const handlePermissionChange = (e) => {
        const { name, checked } = e.target;
        setPermissions(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors: any = {};

        if (!name) {
            newErrors.name = t('staff.err.nameReq');
            isValid = false;
        } else if (name.length > 255) {
            newErrors.name = t('staff.err.nameLong');
            isValid = false;
        }

        if (!email) {
            newErrors.email = t('staff.err.emailReq');
            isValid = false;
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = t('staff.err.emailInvalid');
            isValid = false;
        }

        if (type === 'general') {
            if (!Object.values(permissions).some(v => v)) {
                newErrors.permissions = t('staff.err.permReq');
                isValid = false;
            }
        }

        if (!password) {
            newErrors.password = t('staff.err.passReq');
            isValid = false;
        } else if (password.length < 8) {
            newErrors.password = t('staff.err.passShort');
            isValid = false;
        }

        if (password !== passwordConfirmation) {
            newErrors.password_confirmation = t('staff.err.passMatch');
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const handleAdd = () => {
        if (validateForm()) {
            // Преобразование выбранных прав в массив строк
            const selectedPermissions = Object.entries(permissions)
                .filter(([key, value]) => value)
                .map(([key]) => key);

            const newPersonel = {
                name,
                email,
                role: type,
                password,
                password_confirmation: passwordConfirmation,
                ...(type === 'general' && { permissions: selectedPermissions })
            };

            onAdd(newPersonel);

            // Очистка полей и закрытие формы
            setName('');
            setEmail('');
            setPassword('');
            setPasswordConfirmation('');
            setType('');
            setPermissions({
                'manage-tables': false,
                'manage-quick-orders': false,
                'manage-customers': false,
                'access-payments': false,
                'manage-payments': false,
                'manage-tanimlar': false,
                'manage-restaurants': false,
            });
            onClose();
        }
    };

    return (
        <div className='bg-white p-4 rounded shadow-lg'>
            <h4 className='font-semibold mb-3'>{t('modal.newStaff')}</h4>
            <div className='mb-3'>
                <label className='block mb-1'>{t('courier.fullName')}</label>
                <input
                    type='text'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className={`border rounded w-full p-2 ${errors.name ? 'border-red-500' : ''}`}
                />
                {errors.name && <p className='text-red-500 text-sm'>{errors.name}</p>}
            </div>
            <div className='mb-3'>
                <label className='block mb-1'>{t('staff.email')}</label>
                <input
                    type='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={`border rounded w-full p-2 ${errors.email ? 'border-red-500' : ''}`}
                />
                {errors.email && <p className='text-red-500 text-sm'>{errors.email}</p>}
            </div>
            <div className='mb-3'>
                <label className='block mb-1'>{t('staff.password')}</label>
                <input
                    type='password'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={`border rounded w-full p-2 ${errors.password ? 'border-red-500' : ''}`}
                />
                {errors.password && <p className='text-red-500 text-sm'>{errors.password}</p>}
            </div>
            <div className='mb-3'>
                <label className='block mb-1'>{t('staff.passwordConfirm')}</label>
                <input
                    type='password'
                    value={passwordConfirmation}
                    onChange={(e) => setPasswordConfirmation(e.target.value)}
                    className={`border rounded w-full p-2 ${errors.password_confirmation ? 'border-red-500' : ''}`}
                />
                {errors.password_confirmation && <p className='text-red-500 text-sm'>{errors.password_confirmation}</p>}
            </div>
            <div className='mb-3'>
                <label className='block mb-1'>{t('staff.type')}</label>
                <select
                    value={type}
                    onChange={handleTypeChange}
                    className='border rounded w-full p-2'
                >
                    <option value=''>{t('modal.select')}</option>
                    <option value='general'>{t('staff.roleGeneral')}</option>
                    <option value='waiter'>{t('staff.roleWaiter')}</option>
                </select>
            </div>

            {type === 'general' && (
                <div className='mb-3'>
                    <h4 className='font-semibold mb-2'>{t('staff.authorization')}</h4>
                    <div className='flex flex-col'>
                        {Object.entries(permissions).map(([key, value]) => (
                            <label key={key} className='flex items-center mb-2'>
                                <input
                                    type='checkbox'
                                    name={key}
                                    checked={value}
                                    onChange={handlePermissionChange}
                                    className='mr-2'
                                />
                                {permissionLabels[key]} {/* Отображение удобочитаемых строк */}
                            </label>
                        ))}
                    </div>
                    {errors.permissions && <p className='text-red-500 text-sm'>{errors.permissions}</p>}
                </div>
            )}

            <div className='flex justify-end gap-2'>
                <button onClick={onClose} className='bg-gray-500 text-white py-1 px-3 rounded'>{t('common.cancel')}</button>
                <button onClick={handleAdd} className='bg-blue-500 text-white py-1 px-3 rounded'>{t('common.add')}</button>
            </div>
        </div>
    );
}

export default AddPersonel;


